export const INVOICE_V2 = '2025-11-24'
